export interface ClientTestimonial {
  name: string
  role: string
  city: string
  quote: string
  stars: number
}

export const clientTestimonials: ClientTestimonial[] = [
  {
    name: 'Marcelo G.',
    role: 'Carpintería familiar',
    city: 'Quilmes, Buenos Aires',
    quote:
      'Lo que más me sirvió fue tener ideas ordenadas. Yo ya trabajo en carpintería, pero muchas veces perdía tiempo buscando referencias para mostrarle al cliente. Con La Bóveda tengo varios modelos para arrancar más rápido y adaptar según la medida que me pidan.',
    stars: 5,
  },
  {
    name: 'Rodrigo M.',
    role: 'Empezando desde cero',
    city: 'Córdoba Capital',
    quote:
      'Compré el material porque quería hacer muebles para mi casa y no sabía por dónde empezar. Me gustó que no es solo inspiración, sino que está separado por tipos de proyectos. Para alguien que recién arranca, tener algo ordenado ayuda muchísimo.',
    stars: 5,
  },
  {
    name: 'Diego F.',
    role: 'Carpintero independiente',
    city: 'Rosario, Santa Fe',
    quote:
      'Yo venía haciendo trabajos chicos, repisas y alguna mesa simple. Lo que me destrabó fue ver más proyectos de melamina y muebles modernos. Te abre la cabeza para ofrecer cosas nuevas sin estar inventando todo desde cero.',
    stars: 5,
  },
  {
    name: 'Lucas A.',
    role: 'Emprendimiento de muebles',
    city: 'Mendoza',
    quote:
      'Me sirvió para organizar mejor qué ofrecer. Antes subía cualquier cosa a Instagram, medio improvisado. Ahora tengo más ideas para armar publicaciones, mostrar modelos y responderle mejor a la gente cuando pregunta por un mueble.',
    stars: 4,
  },
  {
    name: 'Pablo R.',
    role: 'Taller de carpintería',
    city: 'Santa Fe',
    quote:
      'En el taller siempre necesitamos referencias rápidas. A veces el cliente te dice “quiero algo parecido a esto” y tenés que resolver. La Bóveda está buena porque te da variedad: cocinas, placares, escritorios, muebles de TV. No es una sola categoría.',
    stars: 5,
  },
  {
    name: 'Matías L.',
    role: 'Aficionado a la carpintería',
    city: 'San Miguel de Tucumán',
    quote:
      'Tenía taladro, caladora y algunas herramientas básicas, pero me faltaban proyectos claros. Me gustó mucho la parte de Carpintería Desde Cero porque explica cosas simples que uno da por sabidas, pero cuando arrancás te hacen falta.',
    stars: 5,
  },
  {
    name: 'Sergio V.',
    role: 'Trabajos en melamina',
    city: 'Morón, Buenos Aires',
    quote:
      'Trabajo bastante con melamina y siempre vienen bien diseños nuevos. Lo bueno es que no tuve que buscar en diez lugares distintos. Entrás, mirás categorías y sacás ideas para adaptar a lo que te pide cada cliente.',
    stars: 5,
  },
  {
    name: 'Claudio B.',
    role: 'Proyectos para el hogar',
    city: 'Neuquén',
    quote:
      'Yo no soy carpintero profesional. Lo compré para hacer cosas en casa, principalmente un escritorio y unas repisas. Me gustó porque te da ganas de hacer más proyectos. Eso está bueno, porque uno deja de quedarse mirando videos y empieza a planear algo concreto.',
    stars: 5,
  },
  {
    name: 'Federico S.',
    role: 'Carpintero independiente',
    city: 'Mar del Plata, Buenos Aires',
    quote:
      'Lo de presupuestar me pareció clave. Muchas veces uno cobra mal por no calcular bien materiales, tiempo y margen. No digo que te resuelva todo mágicamente, pero te ayuda a ordenar la cabeza antes de pasar un precio.',
    stars: 4,
  },
  {
    name: 'Nicolás P.',
    role: 'Empezando a vender muebles',
    city: 'Salta',
    quote:
      'Arranqué haciendo muebles chicos para conocidos y me costaba saber qué ofrecer después. La Bóveda me dio muchas ideas para armar un catálogo inicial. Para mí el valor está en tener variedad y no empezar cada proyecto de cero.',
    stars: 5,
  },
]
